export type Identity =
  | 'American Indian or Alaska Native'
  | 'Black or African American'
  | 'East Asian'
  | 'Hispanic or Latinx'
  | 'Native Hawaiian and Pacific Islander'
  | 'South Asian'
  | 'White'
  | 'Other'
  | 'Confidential'

export const RACE_ETHNICITY_OPTIONS = [
  {
    label: 'White',
    value: 'White',
  },
  {
    label: 'Hispanic or Latinx',
    value: 'Hispanic or Latinx',
  },
  {
    label: 'Black or African American',
    value: 'Black or African American',
  },
  {
    label: 'East Asian',
    value: 'East Asian',
  },
  {
    label: 'South Asian',
    value: 'South Asian',
  },
  {
    label: 'American Indian or Alaska Native',
    value: 'American Indian or Alaska Native',
  },
  {
    label: 'Native Hawaiian and Pacific Islander',
    value: 'Native Hawaiian and Pacific Islander',
  },
  {
    label: 'Other',
    value: 'Other',
  },
  {
    label: 'I prefer not to say',
    value: 'Confidential',
  },
]
